export default __webpack_public_path__ + "static/media/hide_it_app.83dc83f4.png";